import React from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(1),
    color: "darkgray"
  }
}));

export default function NullChip() {
  const classes = useStyles();

  return <Chip size="small" label="null" className={classes.chip} />;
}
